/**
 * Marketplace feature flag utilities
 */

/**
 * Check if the marketplace feature is enabled
 */
export function isMarketplaceEnabled(): boolean {
  return process.env.NEXT_PUBLIC_MARKETPLACE_FEATURE_FLAG === "true";
}

/**
 * Get the appropriate URL based on marketplace feature flag
 * @param targetUrl - The intended destination URL
 * @returns Either the target URL or /coming-soon based on feature flag
 */
export function getMarketplaceUrl(targetUrl: string): string {
  return isMarketplaceEnabled() ? targetUrl : "/coming-soon";
}
